// src/store/contactSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/addContracts/initialState.addcontracts.data';
import {
  fetchAccountingGroupsData as fetchAccountingGroupsAPI,
  fetchCountriesData as fetchCountriesAPI,
  fetchCustomerData as fetchCustomerAPI,
  fetchSiteAndBillToData as fetchSiteAndBillToDataAPI,
  createNewContract as createNewContractAPI,
  fetchSiteTypeData as fetchSiteTypeAPI,
  returnToCreateNewContract as returnToCreateNewContractAPI,
} from '../../../../apis/contractsAPI';
import { CONTRACTS_DATA, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_ADD_NEW_CONTRACT } from '../../../../constants/actionCreator';

export const fetchAccountingGroups = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.FETCH_ACCOUNTING_GROUPS,
  fetchAccountingGroupsAPI
);

export const fetchCountries = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.FETCH_COUNTRIES,
  fetchCountriesAPI
);

export const fetchCustomers = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.FETCH_CUSTOMER,
  fetchCustomerAPI
);

export const fetchBillTos = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.FETCH_BILLTO,
  fetchSiteAndBillToDataAPI
);

export const fetchSites = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.FETCH_SITE,
  fetchSiteAndBillToDataAPI
);

export const createNewContractData = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.CREATE_NEW_CONTRACT,
  createNewContractAPI
);

export const fetchSiteType = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.FETCH_SITE_TYPE,
  fetchSiteTypeAPI
);

export const returnToCreateNewContractData = createAsyncThunkWrapper(
  ACTIONS_ADD_NEW_CONTRACT.RETURN_TO_CREATE_NEW_CONTRACT,
  returnToCreateNewContractAPI
);




const AddContractsSlice = createSlice({
  name: 'addContracts',
  initialState,
  reducers: {
    //Short Name
    handleShortName: (state, action) => {
      state.addContractData.shortName = action?.payload;
    },
    //Accounting Modal
    setSelectedAccountGridRowsData: (state, action) => {
      state.gridAccountingRowSelectedData =
        action?.payload?.length > 0
          ? action?.payload
          : CONTRACTS_DATA.inputModalDefaultVal;
      state.gridAccountingRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.addContractData.accountingGroupName = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : CONTRACTS_DATA.inputModalDefaultVal;
      state.addContractData.accountingGroupCode = action?.payload[0]
        ?.accountingGroupCode
        ? action?.payload[0]?.accountingGroupCode
        : '';
      state.openAccountingGroupModal = false;
    },
    handleFilteredAccountingGroupData: (state, action) => {
      state.accountingGroupSearchData = action?.payload;
    },
    setAccountingGroupModalOpen: (state) => {
      state.openAccountingGroupModal = true;
      state.accountingGroupSearchForm = initialState.accountingGroupSearchForm;
    },
    setAccountingGroupModalClose: (state) => {
      state.openAccountingGroupModal = false;
      state.accountingGroupSearchForm = initialState.accountingGroupSearchForm;
    },
    setAccouningGroupFormFeilds: (state, action) => {
      state.accountingGroupSearchForm[action?.payload?.name] =
        action?.payload?.value;
    },
    //Country Modal
    setSelectedCountryGridRowsData: (state, action) => {
      state.gridCountryRowSelectedData =
        action?.payload?.length > 0
          ? action?.payload
          : CONTRACTS_DATA.inputModalDefaultVal;
      state.gridCountryRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.addContractData.countryName = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : '';
      state.addContractData.countryId = action?.payload[0]?.countryId
        ? action?.payload[0]?.countryId
        : 0;
      state.addContractData.deferralCountryId = action?.payload[0]?.countryId
        ? action?.payload[0]?.countryId
        : 0;
      state.openCountryModal = false;
    },
    handleFilteredCountryData: (state, action) => {
      state.countrySearchData = action?.payload;
    },
    setCountryModalOpen: (state) => {
      state.openCountryModal = true;
      state.countrySearchForm = initialState.countrySearchForm;
    },
    setCountryModalClose: (state) => {
      state.openCountryModal = false;
      state.countrySearchForm = initialState.countrySearchForm;
    },
    setCountryFormFeilds: (state, action) => {
      state.countrySearchForm[action?.payload?.name] = action?.payload?.value;
    },
    //Customer
    setSelectedCustomerGridRowsData: (state, action) => {
      state.gridCustomerRowSelectedData =
        action?.payload?.length > 0
          ? action?.payload
          : CONTRACTS_DATA.inputModalDefaultVal;
      state.gridCustomerRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.addContractData.customerName = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : '';
      state.addContractData.customerId = action?.payload[0]?.customerId
        ? action?.payload[0]?.customerId
        : 0;
      state.openCustomerModal = false;
      state.openBillToCorporateCustomerModal = false;
      state.openBillToCustomerModal = false;
      state.openSiteCorporateCustomerModal = false;
      state.openSiteBillToCustomerModal = false;
    },
    handleFilteredCustomerData: (state, action) => {
      state.customerSearchData = action?.payload;
    },
    setCustomerModalOpen: (state) => {
      state.openCustomerModal = true;
      state.customerSearchForm = initialState.customerSearchForm;
      state.showCustomerSearchGrid = false;
    },
    setCustomerModalClose: (state) => {
      state.openCustomerModal = false;
      state.customerSearchForm = initialState.customerSearchForm;
      state.showCustomerSearchGrid = false;
      state.openBillToCorporateCustomerModal = false;
      state.openBillToCustomerModal = false;
      state.openSiteCorporateCustomerModal = false;
      state.openSiteBillToCustomerModal = false;
    },
    setCustomerFormFeilds: (state, action) => {
      state.customerSearchForm[action?.payload?.name] = action?.payload?.value;
    },
    handleResetCustomerForm: (state) => {
      if(state.openBillToCustomerModal){
        state.billToSearchForm.billToCustomer = initialState.billToSearchForm.billToCustomer;
      }
      if(state.openSiteBillToCustomerModal){
        state.siteSearchForm.billToCustomer = initialState.siteSearchForm?.billToCustomer;
      }
      state.customerSearchForm = initialState.customerSearchForm;
    },
    handleShowCustomerSearchGrid: (state, action) => {
      state.showCustomerSearchGrid = action?.payload;
    },
    //BillTo
    setSelectedBillToGridRowsData: (state, action) => {
      state.gridBillToRowSelectedData =
        action?.payload?.length > 0
          ? action?.payload
          : CONTRACTS_DATA.inputModalDefaultVal;
      state.gridBillToRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.addContractData.billToName = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : '';
      state.addContractData.billToId = action?.payload[0]?.id
        ? action?.payload[0]?.id
        : 0;
      state.openBillToModal = false;
      state.openBillToCorporateCustomerModal = false;
      state.openBillToCustomerModal = false;

    },
    handleFilteredBillToData: (state, action) => {
      state.billToSearchData = action?.payload;
    },
    setBillToModalOpen: (state) => {
      state.openBillToModal = true;
      state.billToSearchForm = initialState.billToSearchForm;
      state.showBillToSearchGrid = false;
    },
    setBillToModalClose: (state) => {
      state.openBillToModal = false;
      state.billToSearchForm = initialState.billToSearchForm;
    },
    setBillToFormFeilds: (state, action) => {
      state.billToSearchForm[action?.payload?.name] = action?.payload?.value;
    },
    handleBillToCorporateCustomerFormFeilds: (state, action) => {
      state.billToSearchForm.corporateCustomer[action?.payload?.name] =
        action?.payload?.value;
    },
    handleBillToCustomerFormFeilds: (state, action) => {
      state.billToSearchForm.billToCustomer[action?.payload?.name] =
        action?.payload?.value;
    },
    handleBillToCorporateCustomerModal: (state, action) => {
      state.openBillToCorporateCustomerModal = action?.payload;
      state.showCustomerSearchGrid = false;
      if (action?.payload) {
        state.openBillToModal = false;
        state.openCustomerModal = true;
        state.billToSearchForm.corporateCustomer =
          initialState.billToSearchForm.corporateCustomer;
      } else {
        state.openBillToModal = true;
        state.openCustomerModal = false;
      }
    },
    handleBillToCustomerModal: (state, action) => {
      state.openBillToCustomerModal = action?.payload;
      state.showCustomerSearchGrid = false;
      if (action?.payload) {
        state.openBillToModal = false;
        state.openCustomerModal = true;
        state.billToSearchForm.billToCustomer =
          initialState.billToSearchForm.corporateCustomer;
      } else {
        state.openBillToModal = true;
        state.openCustomerModal = false;
      }
    },
    handleResetBillToForm: (state) => {
      state.billToSearchForm = initialState.billToSearchForm;
    },
    handleShowBillToSearchGrid: (state, action) => {
      state.showBillToSearchGrid = action?.payload;
    },
    handleSelectedBillToCustomerGridRowsData: (state, action) => {
      state.gridCustomerRowSelectedData =
      action?.payload?.length > 0
        ? action?.payload
        : CONTRACTS_DATA.inputModalDefaultVal;
      state.gridCustomerRowSelectedCount =
      action?.payload?.length > 0 ? action?.payload?.length : 0;
      if(state.openBillToCorporateCustomerModal){
        state.billToSearchForm.corporateCustomer.name = action?.payload[0]
        ? action?.payload[0]?.name
        : '';
        state.billToSearchForm.corporateCustomer.customerId = action?.payload[0]?.customerId
        ? action?.payload[0]?.customerId
        : 0;
      }
      if(state.openBillToCustomerModal){
        state.billToSearchForm.billToCustomer.name = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : '';
        state.billToSearchForm.billToCustomer.customerId = action?.payload[0]?.customerId
        ? action?.payload[0]?.customerId
        : 0;
      }
  },
    //Site
    setSelectedSiteGridRowsData: (state, action) => {
      state.gridSiteRowSelectedData =
        action?.payload?.length > 0
          ? action?.payload
          : CONTRACTS_DATA.inputModalDefaultVal;
      state.gridSiteRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.addContractData.siteName = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : '';
      state.addContractData.siteId = action?.payload[0]?.id
        ? action?.payload[0]?.id
        : 0;
      state.openSiteModal = false;
      state.openSiteCorporateCustomerModal = false;
      state.openSiteBillToCustomerModal = false;
    },
    handleFilteredSiteData: (state, action) => {
      state.siteSearchData = action?.payload;
    },
    setSiteModalOpen: (state) => {
      state.openSiteModal = true;
      state.siteSearchForm = initialState.siteSearchForm;
      state.showSiteSearchGrid = false;
    },
    setSiteModalClose: (state) => {
      state.openSiteModal = false;
      state.siteSearchForm = initialState.siteSearchForm;
    },
    setSiteFormFeilds: (state, action) => {
      state.siteSearchForm[action?.payload?.name] = action?.payload?.value;
    },
    handleSiteCorporateCustomerFormFeilds: (state, action) => {
      state.siteSearchForm.corporateCustomer[action?.payload?.name] =
        action?.payload?.value;
    },
    handleSiteBillToCustomerFormFeilds: (state, action) => {
      state.siteSearchForm.billToCustomer[action?.payload?.name] =
        action?.payload?.value;
    },
    handleSiteCorporateCustomerModal: (state, action) => {
      state.openSiteCorporateCustomerModal = action?.payload;
      state.showCustomerSearchGrid = false;
      if (action?.payload) {
        state.openSiteModal = false;
        state.openCustomerModal = true;
        state.siteSearchForm.corporateCustomer =
          initialState.siteSearchForm.corporateCustomer;
      } else {
        state.openSiteModal = true;
        state.openCustomerModal = false;
      }
    },
    handleSiteBillToCustomerModal: (state, action) => {
      state.openSiteBillToCustomerModal = action?.payload;
      state.showCustomerSearchGrid = false;
      if (action?.payload) {
        state.openSiteModal = false;
        state.openCustomerModal = true;
        state.siteSearchForm.billToCustomer =
          initialState.siteSearchForm.billToCustomer;
      } else {
        state.openSiteModal = true;
        state.openCustomerModal = false;
      }
    },
    handleResetSiteForm: (state) => {
      state.siteSearchForm = initialState.siteSearchForm;
    },
    handleShowSiteSearchGrid: (state, action) => {
      state.showSiteSearchGrid = action?.payload;
    },
    handleSelectedSiteCustomerGridRowsData: (state, action) => {
      if(state.openSiteCorporateCustomerModal){
        state.siteSearchForm.corporateCustomer.name = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : '';
        state.siteSearchForm.corporateCustomer.customerId = action?.payload[0]?.customerId
        ? action?.payload[0]?.customerId
        : 0;
        state.openSiteCorporateCustomerModal = false;
      }
      if(state.openSiteBillToCustomerModal){
        state.siteSearchForm.billToCustomer.name = action?.payload[0]?.name
        ? action?.payload[0]?.name
        : '';
        state.siteSearchForm.billToCustomer.customerId = action?.payload[0]?.customerId
        ? action?.payload[0]?.customerId
        : 0;
        state.openSiteBillToCustomerModal = false;
      }
      state.openSiteModal = true;
      state.openCustomerModal = false;
    },
    //Status
    handleStatusFormFields: (state, action) => {
      state.addContractData.statusId = action?.payload?.value;
    },
    //Level
    handleLevelFormFields: (state, action) => {
      state.addContractData.levelId = action?.payload?.value;
    },
    //Contracts Grid Data
    setSelectedContractsGridRowsData: (state, action) => {
      state.contractsSearchGridRowSelectedData =
        action?.payload?.length > 0 ? action?.payload : [];
      state.contractsSearchGridRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
    },
    //Reset Contracts Add New Form
    handleReset: () => initialState,
    handleResetForm: (state, action) => {
      state.filteredData = action?.payload;
    },
    //Errors and Responses
    setValidationError: (state, action) => {
      state.errors = action?.payload;
    },
    setAPISuccessResponse: (state, action) => {
      state.apiSuccessResponse = {
        ...state.apiSuccessResponse,
        ...action.payload,
      };
    },
    // handle Add Contracts Data
    handleAddContractData: (state, action) => {
      state.addContractData[action?.payload?.name] = action?.payload?.value;
    },
    //handle Add Contract From Error
    handleAddContractError: (state, action) => {
      state.errors = action?.payload;
    },
    // handle Add COntract Data Success
    handleAddContractDataSuccess: (state, action) => {
      state.isContractSuccessfullyCreated = action?.payload;
    },
    handleIsFromCreateNewContract: (state, action) => {
      state.isFromCreateNewContract = action?.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountingGroups.pending, (state) => {
        state.loading = true;
        state.accountingGroupSearchData = [];
        state.isAccountingGroupsResultsFound = null;
      })
      .addCase(fetchAccountingGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.accountingGroups = action?.payload
          ? action?.payload?.accountingGroups
          : [];
        state.accountingGroupSearchData = action?.payload?.accountingGroups
          ? action?.payload?.accountingGroups
          : [];
        state.accountingGroupGridTotalRecords = action?.payload
          ? action?.payload?.totalCount
          : 0;
        state.isAccountingGroupsResultsFound =
          action?.payload?.accountingGroups?.length === 0;
      })
      .addCase(fetchAccountingGroups.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.accountingGroupSearchData = [];
        state.accountingGroupGridTotalRecords = 0;
        state.isAccountingGroupsResultsFound = true;
      })

      .addCase(fetchCountries.pending, (state) => {
        state.loading = true;
        state.countrySearchData = [];
        state.isCountryResultsFound = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action?.payload;
        state.countrySearchData =action?.payload?.country || [];
        state.countryGridTotalRecords = action?.payload
          ? action?.payload?.totalCount
          : 0;
        state.isCountryResultsFound = action?.payload?.length === 0;
        
        })
      .addCase(fetchCountries.rejected, (state, action) => {
        handleRejection(state, action);
        state.countrySearchData = [];
        state.countryGridTotalRecords = 0;
        state.isCountryResultsFound = true;
      })

      .addCase(fetchCustomers.pending, (state) => {
        state.customerSearchData = [];
        state.isCustomersResultsFound = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action?.payload;
        state.customerSearchData = action?.payload;
        state.customerGridTotalRecords = action?.payload
          ? action?.payload[0]?.totalRecords
          : 0;
        state.isCustomersResultsFound = action?.payload ? action?.payload[0]?.totalRecords > 0 : false;
        state.isCustomerViewResultButtonClicked = false;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        handleRejection(state, action);
        state.customerSearchData = [];
        state.customerGridTotalRecords = 0;
        state.isCustomersResultsFound = true;
      })

      .addCase(fetchBillTos.pending, (state) => {
        state.billToSearchData = [];
        state.isBillTosResultsFound = null;
      })
      .addCase(fetchBillTos.fulfilled, (state, action) => {
        state.loading = false;
        state.billTos = action?.payload?.sites;
        state.billToSearchData = action?.payload?.sites;
        state.billToGridTotalRecords = action?.payload
          ? action?.payload?.sites[0]?.totalRecords
          : 0;
        state.isBillTosResultsFound = action?.payload?.sites?.length === 0;
      })
      .addCase(fetchBillTos.rejected, (state, action) => {
        handleRejection(state, action);
        state.billToSearchData = [];
        state.billToGridTotalRecords = 0;
        state.isBillTosResultsFound = true;
      })

      .addCase(fetchSites.pending, (state) => {
        state.siteSearchData = [];
        state.isSitesResultsFound = null;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.loading = false;
        state.sites = action?.payload?.sites;
        state.siteSearchData = action?.payload?.sites;
        state.siteGridTotalRecords = action?.payload
          ? action?.payload?.sites[0]?.totalRecords
          : 0;
        state.isSitesResultsFound = action?.payload?.totalRecords > 0;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        handleRejection(state, action);
        state.siteSearchData = [];
        state.siteGridTotalRecords = 0;
        state.isSitesResultsFound = true;
      })
      // Add Contract Data
      .addCase(createNewContractData.pending, (state) => {
        state.isContractSuccessfullyCreated = false;
        state.isContractInitiated = true;
        state.isDuplicateContract = false;
        state.viaAddNewContracts = true;
        state.isFromCreateNewContract = true;
      })
      .addCase(createNewContractData.fulfilled, (state, action) => {
        state.loading = false;
        state.addContractData.contractId = action?.payload?.contract_id;
        state.isContractSuccessfullyCreated = true;
        state.isContractInitiated = false;
        state.isDuplicateContract = false;
        state.viaAddNewContracts = true;
        state.isFromCreateNewContract = true;
      })
      .addCase(createNewContractData.rejected, (state) => {
        state.isContractSuccessfullyCreated = false;
        state.isDuplicateContract = true;
        state.isContractInitiated = false;
        state.viaAddNewContracts = true;
        state.isFromCreateNewContract = false;
      })

      // Add Contract Data
      .addCase(returnToCreateNewContractData.pending, (state) => {
        state.loading = true;
      })
      .addCase(returnToCreateNewContractData.fulfilled, (state, ) => {
        state.loading = false;
      })
      .addCase(returnToCreateNewContractData.rejected, (state) => {
        state.loading = false;
      })

      // Site Type
      .addCase(fetchSiteType.pending, (state) => {
        state.siteTypeData = [];
      })
      .addCase(fetchSiteType.fulfilled, (state, action) => {
        state.siteTypeData = action?.payload;
      })
      .addCase(fetchSiteType.rejected, (state) => {
        state.siteTypeData = [];
      });
  },
});

export const {
  handleShortName,
  setSelectedAccountGridRowsData,
  handleFilteredAccountingGroupData,
  setAccountingGroupModalOpen,
  setAccountingGroupModalClose,
  setAccouningGroupFormFeilds,
  setSelectedCountryGridRowsData,
  handleFilteredCountryData,
  setCountryModalOpen,
  setCountryModalClose,
  setCountryFormFeilds,
  setSelectedCustomerGridRowsData,
  handleFilteredCustomerData,
  setCustomerModalOpen,
  setCustomerModalClose,
  setCustomerFormFeilds,
  setSelectedBillToGridRowsData,
  handleFilteredBillToData,
  setBillToModalOpen,
  setBillToModalClose,
  setBillToFormFeilds,
  setSelectedSiteGridRowsData,
  handleFilteredSiteData,
  setSiteModalOpen,
  setSiteModalClose,
  setSiteFormFeilds,
  handleStatusFormFields,
  handleLevelFormFields,
  setSelectedContractsGridRowsData,
  handleAddContractData,
  handleReset,
  handleResetForm,
  setValidationError,
  setAPISuccessResponse,
  handleAddContractError,
  handleAddContractDataSuccess,
  handleResetCustomerForm,
  handleShowCustomerSearchGrid,
  handleBillToCorporateCustomerFormFeilds,
  handleBillToCustomerFormFeilds,
  handleBillToCorporateCustomerModal,
  handleBillToCustomerModal,
  handleSiteCorporateCustomerFormFeilds,
  handleSiteBillToCustomerFormFeilds,
  handleSiteCorporateCustomerModal,
  handleSiteBillToCustomerModal,
  handleResetBillToForm,
  handleShowBillToSearchGrid,
  handleResetSiteForm,
  handleShowSiteSearchGrid,
  handleSelectedBillToCustomerGridRowsData,
  handleSelectedSiteCustomerGridRowsData,
  handleIsFromCreateNewContract,
} = AddContractsSlice.actions;

export default AddContractsSlice.reducer;
